module.exports = __webpack_public_path__ + "static/media/petType-lizard.d7b6fd22.jpg";